export const SUPPORT_SUBSCRIPTION_PATHS = [
  'supportSubscriptions',
  'support_subscriptions',
  'supporterSubscriptions',
  'supporter_subscriptions',
  'support.subscriptions',
  'support.supporter_subscriptions',
  'support.support_subscriptions',
  'support.active_subscriptions',
  'supporting.subscriptions',
  'supporting.contributions',
];

export const PAYMENT_DATA_PATHS = [
  'payments',
  'payments.data',
  'payment_history',
  'paymentHistory',
  'paymentHistory.data',
  'transactions',
  'transactions.data',
  'orders',
  'orders.data',
  'charges',
  'charges.data',
  'support_payments',
  'support.payments',
  'support.contributions',
  'payments_list',
  'payment_entries',
  'paymentEntries',
];

export const CHANNEL_SUBSCRIPTION_PATHS = [
  'channelSubscriptions',
  'channel_subscriptions',
  'subscriptions.channels',
  'subscriptions.channel',
  'channels.subscriptions',
  'channels.active_subscriptions',
  'channels.activeSubscriptions',
  'activeChannelSubscriptions',
  'active_channel_subscriptions',
];

export function resolveValueAtPath(source, path) {
  if (!source || typeof source !== 'object' || typeof path !== 'string') {
    return undefined;
  }
  const parts = path.split('.');
  let cursor = source;
  for (const part of parts) {
    if (!cursor || typeof cursor !== 'object') {
      return undefined;
    }
    cursor = cursor[part];
  }
  return cursor;
}

export function ensureArray(value) {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'object') {
    if (Array.isArray(value.data)) {
      return value.data;
    }
    if (Array.isArray(value.items)) {
      return value.items;
    }
  }
  return [];
}

export function findArrayAtPaths(source, paths) {
  for (const path of paths) {
    const item = resolveValueAtPath(source, path);
    const normalized = ensureArray(item);
    if (normalized.length > 0) {
      return normalized;
    }
  }
  return [];
}

export function normalizeChannelId(raw) {
  if (!raw) {
    return null;
  }
  if (typeof raw === 'string' || typeof raw === 'number') {
    const normalized = String(raw).trim();
    return normalized || null;
  }
  if (typeof raw === 'object') {
    if (typeof raw.toHexString === 'function') {
      const normalized = raw.toHexString().trim();
      return normalized || null;
    }
    if (raw.$oid) {
      return String(raw.$oid);
    }
    if (raw._id) {
      const nested = normalizeChannelId(raw._id);
      if (nested) {
        return nested;
      }
    }
    if (raw.id) {
      const nested = normalizeChannelId(raw.id);
      if (nested) {
        return nested;
      }
    }
    if (raw.channelId) {
      const nested = normalizeChannelId(raw.channelId);
      if (nested) {
        return nested;
      }
    }
    if (raw.channel_id) {
      const nested = normalizeChannelId(raw.channel_id);
      if (nested) {
        return nested;
      }
    }
    if (typeof raw.toString === 'function') {
      const normalized = raw.toString().trim();
      if (normalized && normalized !== '[object Object]') {
        return normalized;
      }
    }
  }
  return null;
}
